import React from 'react';
import { useParams } from "umi";

export default () => {
  const { gamecode: gameCode = '' } = useParams() as { gamecode: string; };
  const link = `/v1/dashboard/game/2/${gameCode}/intlsdk/successRateAndErrorCode`;

  return <div className='dtb-db-iframe-wrap'>
    <iframe
      title="tableau"
      className='dtb-db-iframe dtb-db-errorcode'
      src={link}
    />
  </div>;
};
